const RefreshIcon = (props) => (
  <svg
    width={25}   // increased by 2px
    height={25}  // increased by 2px
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_25901_62147"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_25901_62147)">
      <path
        d="M11.0312 17.875C9.1119 17.875 7.48627 17.2091 6.15435 15.8774C4.82229 14.5456 4.15625 12.9203 4.15625 11.0014C4.15625 9.08249 4.82229 7.4567 6.15435 6.12402C7.48627 4.79134 9.1119 4.125 11.0312 4.125C12.103 4.125 13.1172 4.36326 14.0739 4.83977C15.0304 5.31644 15.826 5.98896 16.4607 6.85735V4.8125C16.4607 4.61771 16.5266 4.45447 16.6584 4.32277C16.7903 4.19092 16.9536 4.125 17.1484 4.125C17.3433 4.125 17.5066 4.19092 17.6381 4.32277C17.7698 4.45447 17.8357 4.61771 17.8357 4.8125V8.90221C17.8357 9.13703 17.7563 9.33381 17.5976 9.49254C17.4387 9.65128 17.2419 9.73065 17.0072 9.73065H12.9175C12.7227 9.73065 12.5594 9.6648 12.4276 9.5331C12.2959 9.40126 12.23 9.23786 12.23 9.04292C12.23 8.84812 12.2959 8.68488 12.4276 8.55319C12.5594 8.42165 12.7227 8.35588 12.9175 8.35588H15.8509C15.3678 7.47083 14.6978 6.77363 13.8411 6.26427C12.9844 5.75476 12.0478 5.5 11.0312 5.5C9.50347 5.5 8.20486 6.03472 7.13542 7.10417C6.06597 8.17361 5.53125 9.47222 5.53125 11C5.53125 12.5278 6.06597 13.8264 7.13542 14.8958C8.20486 15.9653 9.50347 16.5 11.0312 16.5C12.0966 16.5 13.0718 16.2203 13.957 15.6608C14.8422 15.1015 15.5128 14.3552 15.9689 13.4221C16.0558 13.2552 16.1836 13.1386 16.3523 13.0721C16.5209 13.0058 16.6928 13.002 16.8679 13.0607C17.0547 13.1195 17.1855 13.2417 17.2602 13.4273C17.3348 13.6131 17.3286 13.7894 17.2417 13.9563C16.6739 15.1432 15.836 16.093 14.7277 16.8057C13.6195 17.5186 12.3873 17.875 11.0312 17.875Z"
        fill="white"
      />
    </g>
  </svg>
);

export default RefreshIcon;
